import React from "react";

// @material-ui/core components
import {makeStyles} from "@material-ui/core/styles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Info from "components/Typography/Info.js";
import Warning from "components/Typography/Warning.js";
import Rose from "components/Typography/Rose.js";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import intl from 'react-intl-universal';


import Zmage from 'react-zmage'

const useStyles = makeStyles(styles);

export default function WelcomeFree() {
	const classes = useStyles();

	return (
		<div className="cd-section" id="WelcomeFree">

			<div className={classes.sectionGray}>
				<div className={classes.container}>
					<GridContainer>
						<GridItem xs={12} sm={7} md={7}>
							<div className={classes.title}>
								<h3>{intl.get('animation_video')}</h3>
								<h4>
									{intl.get('animation_video_info')}
								</h4>
								<br/>
							</div>
						</GridItem>
					</GridContainer>
					<GridContainer>
						<GridItem xs={12} sm={3} md={3}>
							<Card blog>
								<CardHeader image>
									<a
										style={{cursor: 'pointer'}}
										onClick={() =>
											Zmage.browsing(
												{
													src: 'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/83_%E5%8A%A8%E7%94%BB_%E8%BF%AD%E4%BB%A3.gif',
													zIndex: '10000'
												}
											)
										}
									>

										<img
											src={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/83_%E5%8A%A8%E7%94%BB_%E8%BF%AD%E4%BB%A3_small.gif"}
											alt="..."/>
									</a>
									<div
										className={classes.coloredShadow}
										style={{
											backgroundColor: `#00acc1`,
											opacity: "1"
										}}
									/>
								</CardHeader>
								<CardBody>
									<Info>
										<h6 className={classes.cardCategory}>
											{intl.get('welcome_free_video_info_1')}
										</h6>
									</Info>
									<h4 className={classes.cardTitle}>
										<a href="/mockingbird/13" target={'_blank'}>
											{intl.get('welcome_free_video_1')}
										</a>
									</h4>
								</CardBody>
							</Card>
						</GridItem>
						<GridItem xs={12} sm={3} md={3}>
							<Card blog>
								<CardHeader image>
									<a
										style={{cursor: 'pointer'}}
										onClick={() =>
											Zmage.browsing(
												{
													src: 'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/240_%E5%8A%A8%E7%94%BB_%E5%88%86%E6%B2%BB.gif',
													zIndex: '10000'
												}
											)
										}
									>
										<img
											src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/240_%E5%8A%A8%E7%94%BB_%E5%88%86%E6%B2%BB_small.gif'}
											alt="..."/>
									</a>
									<div
										className={classes.coloredShadow}
										style={{
											backgroundColor: '#ff9800',
											opacity: "1"
										}}
									/>
								</CardHeader>
								<CardBody>
									<Warning>
										<h6 className={classes.cardCategory}>
											{intl.get('welcome_free_video_info_2')}
										</h6>
									</Warning>
									<h4 className={classes.cardTitle}>
										<a href="/mockingbird/10" target={'_blank'}>
											{intl.get('welcome_free_video_2')}
										</a>
									</h4>
								</CardBody>
							</Card>
						</GridItem>
						<GridItem xs={12} sm={3} md={3}>
							<Card blog>
								<CardHeader image>
									<a
										style={{cursor: 'pointer'}}
										onClick={() =>
											Zmage.browsing(
												{
													src: 'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/11_%E5%8A%A8%E7%94%BB_%E5%8F%8C%E6%8C%87%E9%92%88.gif',
													zIndex: '10000'
												}
											)
										}
									>
										<img
											src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/11_%E5%8A%A8%E7%94%BB_%E5%8F%8C%E6%8C%87%E9%92%88_small.gif'}
											alt="..."/>
									</a>
									<div
										className={classes.coloredShadow}
										style={{
											backgroundColor: '#ff9800',
											opacity: "1"
										}}
									/>
								</CardHeader>
								<CardBody>
									<Warning>
										<h6 className={classes.cardCategory}>
											{intl.get('welcome_free_video_info_3')}
										</h6>
									</Warning>
									<h4 className={classes.cardTitle}>
										<a href="/mockingbird/12" target={'_blank'}>
											{intl.get('welcome_free_video_3')}
										</a>
									</h4>
								</CardBody>
							</Card>
						</GridItem>
						<GridItem xs={12} sm={3} md={3}>
							<Card blog>
								<CardHeader image>
									<a
										style={{cursor: 'pointer'}}
										onClick={() =>
											Zmage.browsing(
												{
													src: 'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/466_%E5%8A%A8%E7%94%BB_dp.gif',
													zIndex: '10000'
												}
											)
										}
									>
										<img
											src={'https://robinalgo.oss-cn-shanghai.aliyuncs.com/gifs/466_%E5%8A%A8%E7%94%BB_dp_small.gif'}
											alt="..."/>
									</a>
									<div
										className={classes.coloredShadow}
										style={{
											backgroundColor: '#e91e63',
											opacity: "1"
										}}
									/>
								</CardHeader>
								<CardBody>
									<Rose>
										<h6 className={classes.cardCategory}>
											{intl.get('welcome_free_video_info_4')}
										</h6>
									</Rose>
									<h4 className={classes.cardTitle}>
										<a href="/mockingbird/11" target={'_blank'}>
											{intl.get('welcome_free_video_4')}
										</a>
									</h4>
								</CardBody>
							</Card>
						</GridItem>
					</GridContainer>
					<GridContainer style={{paddingBottom: '32px'}}/>
				</div>
				{/* DYNAMIC COLORED SHADOWS END */}
			</div>
		</div>
	);
}
